// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mainNavigationStyles } from "@vanmeter/Overrides/Widgets/Header/MainNavigation";
import { fontConfig } from "@vanmeter/XDL/constants";
import CaretDown from "@vanmeter/XDL/Icons/IconAngleDownSmall";
import { color, layoutContainer } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        display: flex;
        gap: 16px;
        justify-content: flex-start;
        align-items: center;
        ${layoutContainer}
    `,
};

mainNavigationStyles.itemWrapper = {};

mainNavigationStyles.menuItem = {
    css: css`
        position: relative;
        padding: 0 12px;

        &:after {
            content: "";
            background-color: ${color("common.ui8")};
            height: 6px;
            position: absolute;
            bottom: 0;
            left: 0px;
            width: 0px;
            transition: width 300ms ease-in-out;
        }

        & > ${TypographyStyle} {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 0;
            height: 50px;
            text-transform: capitalize;
        }

        &[data-open],
        &:not([disabled]):hover {
            color: ${color("common.ui19")};
            ${TypographyStyle}, ${IconWrapper} {
                color: ${color("common.ui19")};
            }
        }

        &[data-open] {
            & > ${TypographyStyle} > ${IconWrapper} {
                transform: rotate(180deg);
            }
        }

        &:hover,
        &[data-open] {
            &:after {
                width: 100%;
            }
        }
    `,
};

mainNavigationStyles.menuItemTypography = {
    size: fontConfig.regular.size,
    lineHeight: fontConfig.smallSingleLine.lineHeight,
    color: "common.black",
    weight: fontConfig.weight.bold,
    fontFamily: fontConfig.secondaryFontFamily,
    ellipsis: true,
};

mainNavigationStyles.menuItemIcon = {
    src: CaretDown,
    width: 9,
    height: 13,
    color: "common.ui5",
    css: css`
        visibility: ${({ hasChildren }: any) => (hasChildren ? "visible" : "hidden")};
    `,
};

mainNavigationStyles.mobileWrapper = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};
